import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { environment } from '../../../environments/environment';

const apiUrl = '/auth/hashkey';
let serviceCode = '';
serviceCode = environment.serviceCode;

@Injectable()
export class AuthHashkeyService {

  constructor(private http: Http) { }

  execute(apiKey: string): Promise<any> {

    const url = environment.baseUrl + sessionStorage.getItem('baseUrlCompany') + apiUrl;
    
    const headers = new Headers({
      'Content-Type': 'application/json',
      'x-api-key': '',
      'x-service-code': serviceCode,
      'x-session-key': '',
      'x-csrf-token': ''
    });

    const jsonInput = {
      apiKey: apiKey
    };

    return this.http
      .post(url, JSON.stringify(jsonInput), { headers: headers })
      .toPromise()
      .then(response => response.json() as any)
      .catch(error => {
        let err = error;
        if (error.status === 0) {
          err = new Error('サーバへ接続できませんでした。');
        }
        return Promise.reject(err);
      });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/auth-hashkey/auth-hashkey.service.ts